export default function Alert({type : string}) {
    return (
      <div className="alert-wrapper">
        <div className="alert">
            <p>The e-mail you entered is not valid</p>
        </div>
      </div>
    );
  }